'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	_ = require('underscore'),
	progressAttributeNames = require('./progress-attribute-names'),
	measurementsAttributeNames = require('./measures-attribute-names');
module.exports = function ProgressContentStatusUpdater(activeContent) {
	const self = observable(this),
		findStatus = function (statusName) {
			return activeContent.getAttr(progressAttributeNames.statusConfigAttr)[statusName];
		},
		statusPriority = function (statusName) {
			const s = findStatus(statusName);
			return s && s.priority;
		},
		onActiveContentChanged = function (method, attrs) {
			/*eslint eqeqeq: "off" */
			if (method && attrs && method === 'updateAttr' && attrs[0] == activeContent.id) {
				if (attrs[1] === progressAttributeNames.statusConfigAttr) {
					self.dispatchEvent('configChanged', attrs[2]);
				} else if (attrs[1] === measurementsAttributeNames.configurationAttributeName) {
					self.dispatchEvent('measurementsChanged', attrs[2]);
				}
			}
		},
		clearStatus = function (ideaId) {
			const statusName = activeContent.getAttrById(ideaId, progressAttributeNames.statusAttributeName),
				status = statusName && findStatus(statusName);
			let currentStyle;
			if (status) {
				if (status.icon) {
					activeContent.updateAttr(ideaId, 'icon', false);
				}
				if (status.style) {
					currentStyle = activeContent.getAttrById(ideaId, 'style');
					activeContent.updateAttr(ideaId, 'style', _.omit(currentStyle, _.keys(status.style)));
				}
			}
			activeContent.updateAttr(ideaId, progressAttributeNames.statusAttributeName, false);
		},
		recursiveClear = function (idea) {
			clearStatus(idea.id);
			_.each(idea.ideas, recursiveClear);
		};
	self.setStatusConfig = function (statusConfig) {
		const validatedConfig = {};
		if (!statusConfig) {
			activeContent.updateAttr(activeContent.id, progressAttributeNames.statusConfigAttr, false);
			return;
		}
		_.each(statusConfig, function (element, key) {
			validatedConfig[key] = _.clone(element);
			if (isNaN(validatedConfig[key].priority)) {
				delete validatedConfig[key].priority;
			}
		});
		activeContent.updateAttr(activeContent.id, progressAttributeNames.statusConfigAttr, validatedConfig);
	};
	self.getStatusConfig = function () {
		return activeContent.getAttr(progressAttributeNames.statusConfigAttr);
	};

	self.updateStatus = function (ideaId, newStatusName) {
		let result = false;
		const changeStatus = function (id, statusName) {
				const status = findStatus(statusName);
				let merged;
				if (!status) {
					return false;
				}
				clearStatus(id);
				if (status.style) {
					merged = _.extend({}, activeContent.getAttrById(id, 'style'), status.style);
					activeContent.updateAttr(id, 'style', merged);
				}
				if (status.icon) {
					activeContent.updateAttr(id, 'icon', status.icon);
				}
				return activeContent.updateAttr(id, progressAttributeNames.statusAttributeName, statusName);
			},
			shouldPropagate = function (parent) {
				const childStatusNames = _.uniq(_.map(parent.ideas, function (child) {
					return child.getAttr(progressAttributeNames.statusAttributeName);
				}));
				if (childStatusNames.length === 1) {
					return childStatusNames[0];
				}
				if (!_.some(childStatusNames, statusPriority)) {
					return false;
				}
				return _.max(childStatusNames, statusPriority);
			};
		if (changeStatus(ideaId, newStatusName)) {
			_.each(activeContent.calculatePath(ideaId), function (parent) {
				const parentStatusName = shouldPropagate(parent);
				if (parentStatusName) {
					changeStatus(parent.id, parentStatusName);
				}
			});
			result = true;
		}
		return result;
	};
	self.setMeasurements = function (updatedMeasurements) {
		activeContent.updateAttr(activeContent.id, measurementsAttributeNames.configurationAttributeName, updatedMeasurements);
	};
	self.clear = function () {
		recursiveClear(activeContent);
	};
	self.refresh = function () {
		self.dispatchEvent('configChanged', activeContent.getAttr(progressAttributeNames.statusConfigAttr));
		self.dispatchEvent('measurementsChanged', activeContent.getAttr(measurementsAttributeNames.configurationAttributeName));
	};
	activeContent.addEventListener('changed', onActiveContentChanged);
};
